import script from "./RegSerAero.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegSerAero.vue?vue&type=script&lang=ts&setup=true"

import "./RegSerAero.vue?vue&type=style&index=0&id=31a457ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a457ac"]])

export default __exports__